export default "__VITE_ASSET__ef4d9d52__"